export const KYC_STATUS = {
  UNVERIFIED: "unverified",
  VERIFIED: "verified",
  ADVANCED: "advanced",
  INSTITUTIONAL: "institutional",
} satisfies {
  UNVERIFIED: "unverified";
  VERIFIED: "verified";
  ADVANCED: "advanced";
  INSTITUTIONAL: "institutional";
};

export type KycStatus = (typeof KYC_STATUS)[keyof typeof KYC_STATUS];
